import GridController from 'react-mui-lib/grid/controller';

export default new GridController({
    entity_name: 'promo',
    state_prefix: 'promo_grid'
});
